import http from '@/utils/http';

export function getDictionary(codes) {
  const params = {
    code: codes.join(','),
  };
  return http.get('/dict/list', { params });
}

/**
 * 获取卡种列表
 */

export function getQueryCardTypes(type = 'CARD') {
  return new Promise((resolve, reject) => {
    http.get(`/cardType/queryCardTypes?productType=${type}`).then((res) => {
      if (+res.respCode === 20000) {
        resolve(res);
      } else {
        resolve(res);
      }
    }, (error) => {
      reject(error);
    });
  });
}

export function getCardTypeList() {
  return http.get('/cardType/cardTypeList');
}

// 获取权限资源列表
export function getResourceList() {
  return http.get('/resource/list?userType=MERC');
}

export function queryRegisterCountry() {
  return http.get('/common/getRegisterCountry');
}

export function queryCountryCity(params) {
  return http.get('/common/getCountryCity', { params });
}
// 批量换签
export function confirmResigning(params) {
  return http.post('/merchant/Novation/confirmResigning', { params });
}
